import axiosClient from './axiosClient'
import { TEST_BASEDN_API, TEST_CONNECTION_API } from '~/constants/APIs'

export const ldapApis = {
  testConnection: (server: string | null, port: number | null) =>
    axiosClient.get(TEST_CONNECTION_API, {
      params: { server, port }
    }),

  testBaseDn: (baseDn: string | null) =>
    axiosClient.get(TEST_BASEDN_API, { params: { baseDn: baseDn } })
}
